module.exports = __webpack_public_path__ + "static/media/faboutImgCard1.523ac347.png";